import { AsyncState, StandardLocalWidget, Updater, any, async, fromJSX, loadingAsyncState, nothing } from "widgets-for-react";
import { DateStateUpdaters, DateTestState, ItemWithDates } from "./date.state";
import { DateLayout } from "./date.layout";
import { loadItems } from "./date.api";

const render = (currentState: DateTestState) => fromJSX<Updater<DateTestState>>(setState => DateLayout.ItemList({
  items: currentState.items.kind == "loaded" ? currentState.items.value : [],
  text: currentState.input,
  updateText: (text) => setState(DateStateUpdaters.updateDate(text)),
  saveAndReload: () => {
    const date = currentState.input == "" ? new Date() : new Date(currentState.input)
    setState(DateStateUpdaters.saveAndReload(date))
  },
  saveDisabled: currentState.save.kind == "loading"
}))

export const dateTestWidget : StandardLocalWidget<DateTestState> = (currentState) =>
  any([
    currentState.save.kind == "loading" ? 
      async(currentState.save)
      .map(updater => dateState => ({...dateState, save: updater(dateState.save)})) : 
      nothing(),
    currentState.items.kind == "unloaded" &&
    currentState.save.kind != "loading" ? 
      async(loadingAsyncState(() => loadItems()))   
      .map(updater => dateState => ({...dateState, items: updater(dateState.items)})) :
      nothing(),
    currentState.items.kind == "loaded" ? render(currentState) : nothing()
  ])
  